import type { ReactNode } from 'react';
import logoHorizontal from '@/assets/vapt-menu-logo-right.png';

export function AuthCard({ title, subtitle, children, maxWidth = 440 }: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  /** Largura máxima do cartão; a tela de consentimento do MCP usa uma maior. */
  maxWidth?: number;
}) {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20,
      background: 'var(--color-background)',
    }}>
      <div className="card" style={{ width: '100%', maxWidth, padding: 28, animation: 'fadeUp 0.22s ease' }}>
        <div style={{ marginBottom: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img src={logoHorizontal} alt="Vapt Menu" style={{ height: 26, display: 'block' }} />
            <span style={{
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              color: 'var(--color-text-tertiary)',
            }}>
              Backoffice
            </span>
          </div>
          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: 20, marginTop: 16, marginBottom: 0 }}>{title}</h2>
          {subtitle && <p className="muted" style={{ marginTop: 4, marginBottom: 0 }}>{subtitle}</p>}
        </div>
        {children}
      </div>
    </div>
  );
}
